import { combineReducers } from 'redux';
import authReducer from './authReducer';
import cartReducer from './cartReducer';
import notificationReducer from './notificationReducer';
export default combineReducers({
  auth: authReducer,
  cart:cartReducer,
  notification:notificationReducer
})